import Chip, {ChipProps} from '@mui/material/Chip';

import {styled} from '@mui/material/styles';

export const CChip = styled(Chip)<ChipProps>(
  (/* { theme } */) => ({
  }),
);
